import { v4 as uuidv4 } from 'uuid';
import { TranslateDefaultParser } from '@ngx-translate/core';

const translations = fetch('assets/i18n/en.json');

export class AppError extends Error {
  private readonly timestamp;
  private readonly uuid;

  constructor(message: string, ...params: any[]) {
    const parser = new TranslateDefaultParser();
    // This is somewhat of a hack to get access to the translations without having to rely on Angular dependency injection
    super(translations[message] ? parser.interpolate(translations[message], params) : message);
    this.timestamp = new Date();
    this.uuid = uuidv4();
  }
}
